import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

const appendPrefixUrl = (prefixUrl = {}, url) =>
  [
    `/vendor/${prefixUrl.vendorId}`,
    `/contract/${prefixUrl.contractId}`,
    `/version/${prefixUrl.versionId}`,
    `${url}`,
  ].join('')

export const get = async (prefixUrl) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: appendPrefixUrl(prefixUrl, '/attachment'),
  })

  return response?.data
}

export const store = async (prefixUrl = {}, data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, `/attachment`),
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response?.data
}

export const deleteSingle = async (prefixUrl = {}, attachmentId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: appendPrefixUrl(prefixUrl, `/attachment/${attachmentId}`),
  })

  return response?.data
}
